import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { partial } from '../../util/translation/translation';
import ConnectPayouts from './components/ConnectPayouts';

const p = partial('connect');

// Stripe Connect: the club's payouts. Every club's receivers and fees are
// under Club administration (super-users).
const StripeConnectPage = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">{p('stripeConnect')}</h3>
      </Col>
    </Row>
    <ConnectPayouts />
  </Container>
);

export default StripeConnectPage;
